


const COOKIE_CONSENT_KEY= "cookieConsent";

export const getConsent = ()=>{
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    return consent ? JSON.parse(consent) : null;
};

export const setConsent = (consentObject) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentObject));
};

export const hasUserConsented = ()=>{
    return getConsent() !== null;
};

export const clearConsent = ()=>{
    localStorage.removeItem(COOKIE_CONSENT_KEY);
}
